module.exports = __webpack_public_path__ + "img/issue-3.8af7f25a.svg";